export default __webpack_public_path__ + "static/e-commerce-a75bd22858f3db25ef0c06a6741dcebc.png";